// extracted by css-extract-rspack-plugin
export default {"spinnerWrapper":"_cd3bdd2e","spinner":"_eb06f0bd","spinnerContainer":"_bc0263fa"};